import AmpService from "analytics/amplitude/amplitudeEvents";
import classNames from "classnames";
import Button from "component/design-system/buttons/Button";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useSelector } from "react-redux";
import { RootState } from "store";
import HideIf from "util/HideIf";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import styles from "./generic-recommendation-card.module.scss";

const GenericRecommendationCard = ({ card }: { card: any }) => {
  const { t } = useTranslation("home");
  const { loggedIn } = useSelector((state: RootState) => state.authenticationState);
  const selectedVehicle = useSelector((state: RootState) => state.garage.vehicles[0] ?? null);

  const items = card.items.slice(0, 4);
  const isSingle = items.length === 1;
  const isDouble = items.length === 2;
  const isFeatured = isSingle || isDouble;

  let imageSize = 120;
  if (isSingle) {
    imageSize = 240;
  } else if (isDouble) {
    imageSize = 100;
  }

  const handleItemClick = (item: any) => AmpService.homeRecommendationCardItemClicked({
    cardKey: card.key,
    itemLabel: item.label,
    itemLink: item.link,
    selectedVehicle,
    loggedIn,
  });

  return (
    <div
      className={classNames(styles.card_items, {
        [styles.single]: isSingle,
        [styles.double]: isDouble,
      })}
    >
      {items.map((item: any) => {
        const { href, asPath } = getHrefAndPath({ asPath: item.link });
        return (
          <div key={item.link} className={styles.item}>
            <Link
              href={href}
              as={asPath}
              onClick={() => handleItemClick(item)}
              className={styles.item_link}
            >
              <PAImage
                src={getRelativeImagePath(`/img/ds${item.img}`)}
                alt={item.label}
                width={imageSize}
                height={imageSize}
                className={styles.card_img}
              />
              <PAText
                component="p"
                fontSize={FONT_SIZE[0]}
                color="black"
                className={classNames("p-t-5", "m-b-0", styles.item_description)}
              >
                {item.label}
              </PAText>
            </Link>
            <HideIf show={isFeatured}>
              <Link
                href={href}
                as={asPath}
                onClick={() => handleItemClick(item)}
                className={styles.shop_now_link}
              >
                <Button className={styles.shop_now_button}>
                  {t("Shop Now")}
                </Button>
              </Link>
            </HideIf>
          </div>
        );
      })}
    </div>
  );
};

export default GenericRecommendationCard;
